module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-1280x160-99835216fa081b39353881c5e6256205.webp";